module.exports = __webpack_public_path__ + "static/media/Lato-BoldItalic.f98d1804.ttf";